export default {
  getBoosts: 'boosts/GET_BOOSTS',
  getBoostsSuccess: 'boosts/GET_BOOSTS_SUCCESS',
  getBoostsFailure: 'boosts/GET_BOOSTS_FAILURE',

  update: 'boosts/UPDATE',
  updateSuccess: 'boosts/UPDATE_SUCCESS',
  updateFailure: 'boosts/UPDATE_FAILURE',
};
